import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["count"]
  static values = { min: Number }

  connect() {
    this.update()
    this.element.addEventListener("input", () => this.update())
  }

  update() {
    const textarea = this.element.querySelector("textarea") || this.element.querySelector("input")
    if (!textarea) return

    const length = textarea.value.length
    const min = this.minValue || 0

    if (this.hasCountTarget) {
      this.countTarget.textContent = `${length} / ${min}`

      if (length < min) {
        this.countTarget.classList.add("text-red-500")
        this.countTarget.classList.remove("text-green-500", "text-gray-400")
      } else {
        this.countTarget.classList.add("text-green-500")
        this.countTarget.classList.remove("text-red-500", "text-gray-400")
      }
    }
  }
}
